import './DateTimeField.scss'
import { ChangeEvent } from 'react'
import { DateTimeFieldFragment } from '@/ui-legacy/Field/Field.generated'

type DateTimeFieldProps = {
  onChange: (id: string, dateTime: string) => void
} & DateTimeFieldFragment

export function DateTimeField(props: DateTimeFieldProps) {
  // TODO @RM - handle iso to locale formatting
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.onChange(props.id, event.target.value)
  }

  return (
    <div className="date-time-field">
      <input type="datetime-local" value={props.localDateTime ?? props.dateTime} onChange={handleChange} />
    </div>
  )
}
